<template>
  <div class="line-title-box" :class="{whiteBar}">
    <div class="title-bar">
      <span class="before-line"></span>
      <span class="title-content" v-if="title">
        {{title}}
      </span>
      <span class="title-content" v-else>
        <slot name="title"></slot>
      </span>
      <span class="after-line"></span>
    </div>

    <p class="title-tips">{{titleTip}}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleTip: {
      type: String,
      default: ''
    },
    whiteBar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.line-title-box {
  text-align: center;
  .title-bar {
    margin-bottom: 3px;
    line-height: 45px;
    color: #141414;
    font-size: 0;
    font-weight: 700;
    .title-content {
      margin: 0 50px;
      font-size: 32px;
      vertical-align: middle;
    }
    .before-line {
      display: inline-block;
      width: 128px;
      height: 2px;
      background: linear-gradient(270deg, rgba(153,153,153,0.61) 0%, rgba(153,153,153,0.1) 100%);
      opacity: 0.6;
    }
    .after-line {
      display: inline-block;
      width: 128px;
      height: 2px;
      background: linear-gradient(270deg, rgba(153,153,153,0.1) 0%, rgba(153,153,153,0.61) 100%);
      opacity: 0.6;
    }
  }
  .title-tips {
    line-height: 28px;
    color: #999999;
    font-size: 20px;
    font-weight: 400;
  }
  &.whiteBar {
    .before-line {
      background: linear-gradient(270deg, rgba(225,225,225,0.61) 0%, rgba(225,225,225,0.1) 100%);
    }
    .after-line {
      background: linear-gradient(270deg, rgba(225,225,225,0.1) 0%, rgba(225,225,225,0.61) 100%);
    }
    .title-tips {
      color: #FFFFFF;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/lineTitle.vue